var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"23","height":"2","rx":"1","fill":"black","key":0}),React.createElement("rect",{"x":"5","y":"6","width":"18","height":"2","rx":"1","fill":"black","key":1}),React.createElement("rect",{"x":"10","y":"12","width":"13","height":"2","rx":"1","fill":"black","key":2})]);
}

Hamburger.defaultProps = {"width":"23","height":"14","viewBox":"0 0 23 14","fill":"none"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
